export default "__VITE_ASSET__CVtIrmfH__"